import { AvatarProfileSizeType } from '../../../../../../components/avatarProfile/types/avatarProfileSizeType';
import { AvatarProfileStateType } from '../../../../../../components/avatarProfile/types/avatarProfileStateType';
import { AvatarProfileVariantType } from '../../../../../../components/avatarProfile/types/avatarProfileVariantType';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../text/variants';
const buildCommonInitialsWithLogoProps = (FOUNDATIONS) => ({
    rootContainer: {
        display: 'flex',
        flex_direction: 'column',
        align_items: 'center',
        gap: FOUNDATIONS.spacing_150,
    },
    avatarWrapper: {
        position: 'relative',
    },
    avatarContainer: {
        display: 'flex',
        justify_content: 'center',
        align_items: 'center',
        border_radius: FOUNDATIONS.radius_1000,
        background_color: FOUNDATIONS.color_neutral_bg_300,
        border_style: 'solid',
        border_width: FOUNDATIONS.border_50,
        border_color: FOUNDATIONS.color_neutral_border_static_50,
        width: '3.5rem',
        height: '3.5rem',
    },
    avatarContent: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        display: 'flex',
        align_items: 'center',
        justify_content: 'center',
        pointer_events: 'none',
    },
    initials: {
        font_variant: TextVariantType.FONT_PARAGRAPH_50,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_resources_avatarprofile_selector_initials_font,
    },
    badgeLogoContainer: {
        position: 'absolute',
        bottom: '-0.25rem',
        right: '-0.25rem',
    },
    badgeIconContainer: {
        position: 'absolute',
        bottom: '-0.25rem',
        right: '-0.25rem',
    },
    labelContainer: {
        width: '4.375rem',
    },
    label: {
        font_variant: TextVariantType.FONT_PARAGRAPH_500,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_neutral_font_50,
        text_align: 'center',
    },
});
export const getInitialsWithLogoStyles = (FOUNDATIONS, FONT) => {
    const commonInitialsWithLogoProps = buildCommonInitialsWithLogoProps(FOUNDATIONS);
    return {
        [AvatarProfileVariantType.INITIALS_WITH_LOGO]: {
            [AvatarProfileSizeType.EXTRA_EXTRA_SMALL]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonInitialsWithLogoProps,
                },
            },
            [AvatarProfileSizeType.EXTRA_SMALL]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonInitialsWithLogoProps,
                },
            },
            [AvatarProfileSizeType.SMALL]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonInitialsWithLogoProps,
                },
            },
            [AvatarProfileSizeType.MEDIUM]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonInitialsWithLogoProps,
                },
            },
            [AvatarProfileSizeType.LARGE]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonInitialsWithLogoProps,
                },
            },
            [AvatarProfileSizeType.EXTRA_EXTRA_LARGE]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonInitialsWithLogoProps,
                },
            },
        },
    };
};
//# sourceMappingURL=initialsWithLogo.js.map